<template>
  <div class="d-flex align-items-center justify-content-end w-full">
    <span class="me-2">表示件数</span>
    <Dropdown
      v-model="selectedPerPage"
      :options="options"
      option-label="label"
      option-value="value"
      :allow-empty="false"
      class="me-2"
    />
    <span>{{ currentPage }}/{{ totalPages || 1 }}</span>
  </div>
</template>

<script setup lang="ts">
import Dropdown from "primevue/dropdown";
import { computed } from "vue";

const props = defineProps<{
  totalPages: number;
  currentPage: number;
  perPageOptions?: number[];
}>();

const selectedPerPage = defineModel<number>({
  default: 10,
});

const options = computed(() => {
  return (props.perPageOptions || [20, 30, 50]).map((n) => ({
    label: n.toString(),
    value: n,
  }));
});
</script>

<style scoped></style>
